/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_AwardProgramme } from '../models/db_AwardProgramme';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Programmes {
    /**
     * Get a list of programmes
     * @returns db_AwardProgramme OK
     * @throws ApiError
     */
    public static listProgrammes(): CancelablePromise<Array<db_AwardProgramme>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/programmes',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
